<template>
    <div>
        <BarChart
                v-if="loaded"
                :chartdata="chartdata"
                :options="options"/>
    </div>
</template>
<script>
    import BarChart from './chart-main.vue'

    export default {
        name: 'Promedios',
        components: {BarChart},
        props: {
            resultados: {
                type: Array
            }
        },
        data: () => ({
            id_simulacro:'',
            chartdata: {
                labels: [],
                datasets: [

                    {
                        label: 'Tu puntuacion',
                        backgroundColor: '#583C89',
                        data: []
                    },
                    {
                        label: 'Promedio aula',
                        backgroundColor: '#9CCB48',
                        data: []
                    }
                ]
            },
            loaded: false,
            options: {
                plugins: {
                    datalabels: {
                        formatter: function (value) {
                            return value + ' pts';
                        },
                       // rotation: -90,
                        color: 'black',
                        anchor: 'end',
                        align: 'top',
                        font: {
                            size: "17",
                            weight: 'bold'
                        }
                    }
                },
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        gridLines: {
//                                drawBorder: true,
                            lineWidth: 2,
                            color: '#8D8E8E',
                            drawBorder: false,
                            zeroLineWidth: 3,
                            zeroLineColor: '#555555'
                        },
                        ticks: {
                            fontStyle: 'bold',
                            fontSize: 13,
                            fontColor: '#808080',
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            display: true,
//                                drawBorder: true,
                            lineWidth: 2,
                            color: '#9D9D9C',
                            drawBorder: false,
                            zeroLineWidth: 3,
                            zeroLineColor: '#555555'
                        },
                        ticks: {
                            fontStyle: 'bold',
                            fontSize: 13,
                            fontColor: '#626366',
                            beginAtZero: true,
                            min: 0,
                            stepSize: 30
                        }
                    }],
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }),
        created() {
         this.id_simulacro = localStorage.getItem("id_simulacro")  ? localStorage.getItem("id_simulacro") :this.resultados[0].id_simulacro
        },
        mounted() {
            this.getPromedio()
        },
        methods: {
            getPromedio() { 
                //onsole.log("Aqui resultados", this.resultados)
                   let data = {
        key: localStorage.getItem('keys'),
        id: this.id_simulacro
      };
              
                this.loaded = false
                this.$store.dispatch('getPromedios', data)
                    .then((response) => {
                        for (let i = 0; i < response.data.promedio.length; i++) {
                            this.chartdata.labels.push(response.data.promedio[i].titulo)
                            this.chartdata.datasets[1].data.push(response.data.promedio[i].average)
                        }
                        for (let i = 0; i < this.resultados.length; i++) {
                            this.chartdata.datasets[0].data.push(this.resultados[i].puntaje_total)
                        }
                        this.loaded = true
                    })
                    .catch((error) => {
                        console.log(error.message)
                    })

            }
        },
    }
</script>